import type { PickersProComponents } from "@mui/x-date-pickers-pro/themeAugmentation";
import { Theme } from "@mui/material";
const MuiDateRangePickerDay: NonNullable<PickersProComponents<Theme>["MuiDateRangePickerDay"]> = {
  styleOverrides: {
    rangeIntervalDayHighlightEnd: ({ theme }) => ({
      "& .MuiButtonBase-root": {
        border: `1px solid ${theme.palette.primary.main}`,
        backgroundColor: theme.palette.mode == "light" ? theme.palette.background[200] : theme.palette.background[400],
        color: theme.palette.text.primary,
      },
    }),
  },
};

export default MuiDateRangePickerDay;
